import * as React from 'react';
import { Panel, Row } from 'react-bootstrap';
import { Translate } from '../../../../../../shared/LanguageService';
import { PackageProducts } from './PackageProducts';
import { PlanProducts } from './PlanProducts';
import { ShowcaseProducts } from './ShowcaseProducts';
import { StylingProducts } from './StylingProducts';
import { AdditionalProducts } from './AdditionalProducts';
import { getOtherProductsLabel } from '../state/productHelper';
import { DigitalStylingProducts } from './DigitalStylingProducts';
import { PRODUCT_PANEL_ID } from "../../../../../../debug/orders/createOrder/v1/state/debugFiller";

type CreateOrderProductSelectionProps = {
    additionalProducts: any; // maybe fix type...
    calculatedTotalCost: number;
    currencySign: string;
    digitalStylingProducts: any; // maybe fi
    existingOrderData: any; // maybe fix type...
    onClickAdditionalProduct: (id: number) => void;
    onClickDigitalStylingProduct: (id: number) => void;
    onClickPackageProduct: (id: number) => void;
    onClickPlanProduct: (id: number) => void;
    onClickShowcaseProduct: (id: number) => void;
    onClickStylingProduct: (id: number) => void;
    packageProducts: any; // maybe fix type...
    pendingOrder: any; // maybe fix type...
    planProducts: any; // maybe fix type...
    showPrices: boolean;
    showcaseProducts: any; // maybe fix type...
    stylingProducts: any; // maybe fix type...
};

// GOTO: 1201

function shouldDisplayShowcase(
    pendingOrder: any,
    showcaseProducts: any,
    existingOrderData: any
): boolean {
    return (
        pendingOrder &&
        showcaseProducts.length > 0 &&
        (!existingOrderData || !existingOrderData.existingShowcaseOrderId)
    );
}

export function CreateOrderProductSelection({
    additionalProducts,
    calculatedTotalCost,
    currencySign,
    digitalStylingProducts,
    existingOrderData,
    onClickAdditionalProduct,
    onClickDigitalStylingProduct,
    onClickPackageProduct,
    onClickPlanProduct,
    onClickShowcaseProduct,
    onClickStylingProduct,
    packageProducts,
    pendingOrder,
    planProducts,
    showPrices,
    showcaseProducts,
    stylingProducts
}: CreateOrderProductSelectionProps) {
    let otherProductsLabel = getOtherProductsLabel(
        digitalStylingProducts,
        showcaseProducts,
        stylingProducts
    );

    return (
        <Panel eventKey="2" className="product-selection-panel expand-icon">
            <Panel.Heading>
                <Panel.Title id={PRODUCT_PANEL_ID} toggle>
                    {Translate('orders/create/panel-headings/select-product')}
                    {showPrices ? (
                        <div className="pull-right">
                            <p
                                id={
                                    calculatedTotalCost > 0
                                        ? 'blackFilledBorder'
                                        : 'greyFilledBorder'
                                }
                            >
                                {Translate('orders/create/panel-headings/total-cost')}:{' '}
                                {calculatedTotalCost} {currencySign}
                            </p>
                        </div>
                    ) : null}
                </Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible>
                {packageProducts.length > 0 ? (
                    <PackageProducts
                        products={packageProducts}
                        onClickProduct={onClickPackageProduct}
                    />
                ) : null}

                {additionalProducts.length > 0 ? (
                    <AdditionalProducts
                        products={additionalProducts}
                        onClickProduct={onClickAdditionalProduct}
                    />
                ) : null}

                {planProducts.length > 0 ? (
                    <PlanProducts
                        existingOrderData={existingOrderData}
                        products={planProducts}
                        onClickProduct={onClickPlanProduct}
                    />
                ) : null}

                {otherProductsLabel !== null ? (
                    <Row>
                        <div className="rowlabel">{Translate(otherProductsLabel)}</div>
                        {shouldDisplayShowcase(
                            pendingOrder,
                            showcaseProducts,
                            existingOrderData
                        ) ? (
                            <ShowcaseProducts
                                products={showcaseProducts}
                                onClickProduct={onClickShowcaseProduct}
                            />
                        ) : null}
                        {stylingProducts.length > 0 ? (
                            <StylingProducts
                                products={stylingProducts}
                                onClickProduct={onClickStylingProduct}
                            />
                        ) : null}
                        {digitalStylingProducts.length > 0 ? (
                            <DigitalStylingProducts
                                products={digitalStylingProducts}
                                onClickProduct={onClickDigitalStylingProduct}
                            />
                        ) : null}
                    </Row>
                ) : null}
            </Panel.Body>
        </Panel>
    );
}
